import { z } from 'zod';

type SchemaOptions = {
  includeEmail?: boolean;
  includeHours?: boolean;
}

export const rentalFormSchema = (options: SchemaOptions = {}) => {
  const baseSchema = {
    firstName: z.string().min(2, 'Imię jest wymagane'),
    roomNumber: z.number().min(1, 'Numer pokoju jest wymagany'),
    dateFrom: z.string().min(1, 'Wybierz date rozpoczecia'),
    dateTo: z.string().min(1, 'Wybierz date zakonczenia').optional(),
  };

  if (options.includeHours) {
    Object.assign(baseSchema, {
      timeFrom: z.string().min(1, 'Wybierz godzinę rozpoczęcia'),
      timeTo: z.string().min(1, 'Wybierz godzinę zakończenia'),
    });
  }

  if (options.includeEmail) {
    Object.assign(baseSchema, {
      email: z.string()
        .email('Email jest nieprawidłowy')
        .min(1, 'Email jest wymagany'),
    });
  }

  return z.object(baseSchema);
};
